function getDifferenceInSeconds(startTime: number, endTime: number, secondsOnly?: boolean): string | undefined {
  if (startTime && endTime) {
    let durationSec = Math.floor((endTime - startTime) / 1000);
    if (secondsOnly) return `${durationSec}s`
    const durationMin = Math.floor(durationSec / 60);
    durationSec = durationSec - (60 * durationMin);
    if (durationMin)
      return durationSec ? `${durationMin}m ${durationSec}s` : `${durationMin}m`;
    else
      return `${durationSec}s`
  }
}

export default getDifferenceInSeconds;
